import axios from 'axios'

export const get = (url,params,headers) => {
  return axios({
    url: url,
    method: 'get',
    params : params,
    headers
  })
}

export const post = (url, data, headers) => {
  return axios({
    url: url,
    method: 'post',
    data,
    headers
  })
}




// WEBPACK FOOTER //
// ./src/http/modules/http.js